/**
 * ROUTEPATH are used for routes(it is used for routing)
 * LINK PATH are used in links for consistent naming of route ( it is used in links)
* note LINK PATH should be same name with routepath 
 route => /:subject_id/playquiz
 link => /playquiz

*/

const PATH = {
  HOMEPAGE: "/",
  LOGIN: "login",
  SIGNUP: "signup",
  SEARCH: "search",
  QBANK: "qbanks",
  QBANK_CONTENT: ":subject_id",
  QUIZ_STATUS_ROUTE: ":subject_id/:topic_id/quizstatus",
  QUIZ_STATUS_LINK: "quizstatus",
  PLAY_QUIZ_ROUTE: ":subject_id/:topic_id/playquiz",
  PLAY_QUIZ_LINK: "playquiz",
  VIDEOS: "videos",
  VIDEOS_CONTENT: ":subject_id",
  WATCH_VIDEO: ":subject_id/:video_id",
  TESTS: "tests",
  PLAY_TEST_ROUTE: ":test_id/play_test",
  PLAY_TEST_LINK: "play_test",
};
export default PATH;
